/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'picto-profil-situation-5': {
    width: 63,
    height: 35,
    viewBox: '0 0 63 35',
    data: '<path pid="0" class="st0" d="M31.4 34.4c-.7 0-1.2-.5-1.2-1.2 0-7.7-6.2-13.9-13.9-13.9S2.4 25.5 2.4 33.2c0 .7-.5 1.2-1.2 1.2S0 33.9 0 33.2c0-9 7.3-16.3 16.3-16.3s16.3 7.3 16.3 16.3c0 .7-.6 1.2-1.2 1.2"/><path pid="1" class="st0" d="M16.3 18.9c-5.2 0-9.4-4.2-9.4-9.4S11.1.1 16.3.1s9.4 4.2 9.4 9.4-4.2 9.4-9.4 9.4m0-16.5c-3.9 0-7 3.2-7 7.1 0 3.9 3.2 7 7 7s7-3.2 7-7c0-3.9-3.1-7.1-7-7.1M61.6 34.4c-.7 0-1.2-.5-1.2-1.2 0-7.7-6.2-13.9-13.9-13.9s-13.9 6.2-13.9 13.9c0 .7-.5 1.2-1.2 1.2s-1.2-.5-1.2-1.2c0-9 7.3-16.3 16.3-16.3s16.3 7.3 16.3 16.3c0 .7-.6 1.2-1.2 1.2"/><path pid="2" class="st0" d="M46.5 18.9c-5.2 0-9.4-4.2-9.4-9.4C37 4.2 41.3 0 46.5 0s9.4 4.2 9.4 9.4c0 5.3-4.2 9.5-9.4 9.5m0-16.5c-3.9 0-7 3.2-7 7.1 0 3.9 3.2 7 7 7 3.9 0 7-3.2 7-7 0-3.9-3.1-7.1-7-7.1"/>'
  }
})
